var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.071 4H2.93a.896.896 0 00-.657.293A1.04 1.04 0 002 5v8c0 .265.098.52.272.707.174.188.41.293.657.293H14.07a.896.896 0 00.657-.293A1.04 1.04 0 0015 13V5c0-.265-.098-.52-.272-.707A.896.896 0 0014.071 4zM13.05 5L8.5 8.39 3.95 5h9.1zM2.929 13V5.455L8.235 9.41a.442.442 0 00.53 0l5.306-3.955V13H2.93z"
  })));
}
export default SvgEmailIcon;